import * as Styled from './Text.styled';
import type { TextProps } from './Text.typed';
import React, { forwardRef } from 'react';

export const Text = forwardRef<HTMLElement, TextProps>(
  (props: TextProps, ref) => {
    const {
      forwardedAs = 'p',
      children,
      size = 'M14',
      responsiveSizes,
      weight,
      color,
      display,
      align,
      className,
      underline,
      ...rest
    } = props;
    return (
      <Styled.Text
        ref={ref}
        as={forwardedAs}
        color={color}
        size={size}
        responsiveSizes={responsiveSizes}
        weight={weight}
        align={align}
        className={className}
        display={display}
        $underline={underline}
        {...rest}
      >
        {children}
      </Styled.Text>
    );
  },
);

Text.displayName = 'Text';

export default Text;
